module.exports = __webpack_public_path__ + "static/media/HotQuestion.9fb07e1e.jpg";